import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children, adminOnly = false }) => {
  // Check authentication
  const localToken = localStorage.getItem('mcaToken');
  const sessionToken = sessionStorage.getItem('mcaToken');
  const localUser = localStorage.getItem('mcaUser');
  const sessionUser = sessionStorage.getItem('mcaUser');
  
  const token = localToken || sessionToken;
  const userStr = localUser || sessionUser;
  
  if (!token || !userStr) {
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);
    if (adminOnly) {
      // Strict admin only (staff, admin panel)
      if (user.role !== 'admin') {
        return <Navigate to="/funded-deals" replace />;
      }
    } else {
      // Admin or underwriter allowed
      if (user.role !== 'admin' && user.role !== 'underwriter') {
        return <Navigate to="/funded-deals" replace />;
      }
    }
  } catch (error) {
    console.error('Error parsing user data:', error);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;
